import { SerializedStyles } from "@emotion/react";

export function newSerializedStyles(): { [key: string]: SerializedStyles } {
    return {};
}